import { initApp } from './app'
import './styles/main.css'
import { registerSW } from 'virtual:pwa-register'

const appRoot = document.getElementById('app')
if (!appRoot) {
  throw new Error('Root element #app not found')
}

initApp(appRoot)

registerSW({ immediate: true })
